import React, { useLayoutEffect, useEffect, useState, useRef } from 'react';
import { cachedFetchJson } from '../../helpers/fetch.js';
import { objectOf } from 'prop-types';

import { integration_list_entities_for_project_path } from '~/routes';


/* 
 * Renders the external entity fields for indicator recording
 * Uses selects if fund, otherwise autofills project linked data
 *
 * Used by indicator record & adalia_me_indicator
 */

// DEPRECATED. 

const ExternalEntityInput = ({ 
  projectId, 
  externalEntityColumnDefs, 
  rowIdx, 
  showFieldNames = false, 
  namePrefix = 'values[]', 
  inputSize='sm', 
  wrapperStyle=null, 
  readOnly 
}) => {
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState(null);
  const [dependentOptions, setDependentOptions] = useState(null);
  const [value, setValue] = useState(null);
  const [dependencyMap, setDependencyMap] = useState(null);
  const userSetValue = useRef(true)

  useEffect(() => {
    if (!dependencyMap) { return }
    let depOpts = {...options};

    Object.keys(options).forEach(entityId => {
      const externalId = value ? value[entityId] : null;
      if (externalId && dependencyMap[externalId]){
        Object.keys(dependencyMap[externalId]).forEach(depObjectType => {
          const key = Object.keys(options).find(k => k.includes(depObjectType))
          depOpts[key] = _.pick(options[key], dependencyMap[externalId][depObjectType]);
        })
      }
    })
    setDependentOptions(depOpts);
    setLoading(false);
  },[value, dependencyMap])


  useEffect(() => {
    cachedFetchJson(integration_list_entities_for_project_path({project_id: projectId})).then(response => {
      setOptions(response['options']);
      // If received only 1 option for all, set it as initial.
      if (Object.keys(response['options']).every(k => Object.keys(response['options'][k]).length == 1)) {
        setValue(Object.fromEntries(Object.keys(response['options']).map(r => [r,Object.keys(response['options'][r])[0]])))
      }
      setDependencyMap(response['dependency_map'])
    })
  }, [projectId])

  const handleChange = (extId, mapping) => {
      setLoading(true);
      setValue({...value, [mapping]: extId})      
  }
  
  const preventEdit = (e) => {
    e.preventDefault();
    //Nop
  }

  const getKeyForFormId = (object, mapping) => {
    let retval = Object.keys(object || {}).find(key => key.split(':')[0] == mapping)
    return retval 
  }

  const getWithMapping = (object, mapping) => {
    return object[getKeyForFormId(object, mapping)]
  }

  if (loading || !dependentOptions) return null;
  return <>{
    externalEntityColumnDefs.map((col,idx) => { 
      const colEntityKey = `${col['mapping']}:${col['endpoint']}`;
      const filteredOptions = Object.keys(dependentOptions[colEntityKey] || {});
      let colEntity = value && (value[colEntityKey] == null || filteredOptions.includes(value[colEntityKey])) ? value[colEntityKey] : null;
      let colValue = colEntity ? getWithMapping(value, col['mapping']) : null;

      return <div 
      style={wrapperStyle ? wrapperStyle : {width: idx == externalEntityColumnDefs.length - 1 ? 178 : 180, display: 'inline-block', paddingLeft: 8, paddingRight: 8}}
      key={`external-entity-column-${col['mapping']}::${col['value']}`}  
    >      
    {
      // filteredOptions.length > 1 ? 
      <>
        <input 
          type="hidden"           
          name={`${namePrefix}[additional_information[${col['mapping']}::${col['value']}]]`}
          value={colValue ? options[colEntityKey][colValue][col['value']] : ''}
        />
        <select
          data-row-index={rowIdx}
          type="text"
          disabled={loading}
          placeholder={loading ? I18n.t('loading') : ''}
          value={colEntity}
          onChange={(e) => {    
            e.preventDefault();
            handleChange(e.target.value, colEntityKey)
          }}
          className={`form-control input-${inputSize}`}
          >
            {<option value=''>{I18n.t('select_blank_option_default', {scope: 'fe'})}</option>}
            {filteredOptions.map((extId) => <option value={extId}>{options[colEntityKey][extId][col['value']]}</option>)}
        </select>
        {showFieldNames && <span className="description">{col['name']}</span>}
      </>
    }
    </div>}
    )}
  </>
  

}

export default ExternalEntityInput;